module.exports = __webpack_public_path__ + "static/media/5min_fadeinout.81552c8a.wav";